import PlaceIcon from "@mui/icons-material/Place";
import {
  Alert,
  Box,
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { AccountPageLayout } from "components/common/AccountPageLayout";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import { useMemo } from "react";
import { Link } from "react-router";
import { useListInstallationLocationsQuery } from "src/store/api/generatedApi";

export const ViewerLocationPicker = () => {
  const { t } = useTenantTranslation();
  const tenantName = useTenant();
  const { data: locationsData, isLoading } = useListInstallationLocationsQuery({
    tenantName,
  });

  const locations = useMemo(
    () => locationsData?.map((l) => l.name) ?? [],
    [locationsData]
  );

  return (
    <AccountPageLayout title={t("videoViewer")}>
      <Stack spacing={3} py={4}>
        <Typography variant="h5">{t("selectLocation")}</Typography>
        {isLoading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : locations.length === 0 ? (
          <Alert severity="info">{t("noLocationsConfigured")}</Alert>
        ) : (
          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            {locations.map((location) => (
              <Card key={location} sx={{ minWidth: 200 }}>
                <CardActionArea component={Link} to={location} sx={{ p: 2 }}>
                  <CardContent>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <PlaceIcon color="primary" sx={{ fontSize: 32 }} />
                      <Typography variant="h6">{location}</Typography>
                    </Stack>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </Stack>
        )}
      </Stack>
    </AccountPageLayout>
  );
};
